import { Component, Input } from "@angular/core";
import { LayoutAlignDirective, LayoutDirective } from "@ngbracket/ngx-layout/flex";
import { ForgeLabelValueModule } from "@tylertech/forge-angular";
import { ShortcutInfo } from "../../../services";

@Component({
    selector: "shortcut-group",
    templateUrl: './shortcutGroup.tmpl.html',
    styleUrls: [
        "./shortcutGroup.component.scss"
    ],
    imports: [
        ForgeLabelValueModule,
        LayoutAlignDirective,
        LayoutDirective,
    ]
})
export class ShortcutGroupComponent
{
    @Input() readonly group: string;
    @Input("shortcuts") set boundShortcuts(value: ReadonlyArray<ShortcutInfo>)
    {
        this.shortcuts = [...value];
        this.shortcuts?.sort((a, b) =>
        {
            return a.Keys > b.Keys
                ? 1
                : b.Keys > a.Keys
                    ? -1
                    : 0;
        });
    }

    shortcuts: Array<ShortcutInfo>;
}
